import { twMerge } from "tailwind-merge";
import { ChevronLeft, ChevronRight } from "lucide-react";
import {
  SupportArticleNavigationBase,
  type Article,
} from "@core/features/support";
import { Button } from "@themes/pollinator/ui/Button";

export type Props = {
  prev: Article | null;
  next: Article | null;
  onClick: (article: Article) => void;
};

export function SupportArticleNavigation({ prev, next, onClick }: Props) {
  return (
    <SupportArticleNavigationBase
      prev={prev}
      next={next}
      onNavigate={onClick}
      className={twMerge(
        "flex justify-between w-full",
        !prev && "justify-end",
        !next && "justify-start"
      )}
      renderPrevButton={({ article, onClick: handleClick }) => (
        <Button
          variant="secondary"
          iconComponent={ChevronLeft}
          onClick={handleClick}
          data-testid="support-article-prev"
        >
          {article.title}
        </Button>
      )}
      renderNextButton={({ article, onClick: handleClick }) => (
        <Button
          variant="secondary"
          iconComponent={ChevronRight}
          iconPosition="right"
          onClick={handleClick}
          data-testid="support-article-next"
        >
          {article.title}
        </Button>
      )}
    />
  );
}

export default SupportArticleNavigation;

